<template>
  <div class="schedule-session">
    <div class="schedule-session-format">{{ dimName }}</div>
    <div class="schedule-session-times">
      <div
        v-for="time in theatre.TimesByFormat[format]"
        :key="time.Key"
        @click="onClickOnDate(theatre.Id, time.Key, movieId, time.Time)"
        class="schedule-session-time session-picker-item"
        :class="{ disabled: isDisabledDate(time.Time) }"
      >
        <div class="session-picker-item-time">
          <div class="value">
            {{
              `${new Date(time.Time).getHours()}:${
                // eslint-disable-next-line vue/no-parsing-error
                new Date(time.Time).getMinutes() < 10
                  ? '0' + new Date(time.Time).getMinutes()
                  : new Date(time.Time).getMinutes()
              }`
            }}
          </div>
        </div>
        <div class="session-picker-item-price">от {{ time.MinPrice }} Р</div>
      </div>
    </div>
  </div>
</template>

<script>
import urlQueryParts from '../../../../helpers/urlQueryParts';

export default {
  name: 'TimesByFormat',
  props: ['theatre', 'movieId', 'format'],
  mounted() {},

  computed: {
    dimName() {
      return this.format
        .split('_')
        .map((part) => {
          switch (part) {
            case 'TWO':
              return '2';
            case 'THREE':
              return '3';
            case 'DIM':
              return 'd';
            default:
              return part;
          }
        })
        .join('');
    },
  },
  methods: {
    isDisabledDate(date) {
      return (
        Number(new Date()) -
          Number(new Date(date)) -
          this.theatre.SessionTicketSellDelay * 1000 * 60 >
        0
      );
    },
    onClickOnDate(theatreId, sessionId, filmId, date) {
      if (!this.isDisabledDate(date)) {
        this.$router.push(
          `/${theatreId}/${sessionId}/hall${urlQueryParts({ filmId })}`,
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.schedule-session {
  width: 100%;
  padding: 5px 0;
  gap: 10px;
  display: flex;
}

.schedule-session-times {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-content: flex-start;
  flex-flow: row wrap;
}

.session-picker-item {
  min-width: 81px;
  font-size: 14px;
  margin-right: 24px;

  &.disabled {
    .session-picker-item-time {
      color: #fff;
      border: 1px solid #a6bac3;
      background: #a6bac3;
      cursor: not-allowed;
    }
  }
}

.schedule-session-format {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  text-transform: uppercase;
  font-size: 20px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #fff;
  margin-right: 1.5rem;
}

.session-picker-item-time {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  color: #fff;
  background: #ab2e96;
  border-radius: 6px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 6px 12px;
  cursor: pointer;
}

.session-picker-item-price {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  flex-direction: column;
  flex-wrap: wrap;
  display: flex;
  align-items: center;
  text-align: center;
  color: #b3b3b3;
  margin-top: 0.25rem;
}
</style>
